module.exports = __webpack_public_path__ + "static/media/99.29833f76.png";